import { Controller } from '@hotwired/stimulus';

// Keeps a transient interstitial (the quiz "calculating" page) out of the
// browser history. If it stays in the back stack, pressing Back from the plan
// review page lands on it and its auto-submit immediately forwards to review
// again, trapping the user in a review/calculating (and, further back,
// review/checkout) loop.
export default class extends Controller {
  connect() {
    // Reached via Back/Forward: keep moving in the same direction instead of
    // re-running the interstitial.
    const [nav] = performance.getEntriesByType('navigation');
    if (nav && nav.type === 'back_forward') {
      history.back();
      return;
    }

    this.onPageshow = (event) => {
      if (event.persisted) history.back();
    };
    window.addEventListener('pageshow', this.onPageshow);
  }

  disconnect() {
    window.removeEventListener('pageshow', this.onPageshow);
  }

  // Submits the step over fetch, then replaces the current history entry with
  // the destination, so this page never remains in the back stack.
  submitAndReplace(event) {
    event.preventDefault();
    const form = event.target;

    fetch(form.action, {
      method: 'POST', // the form carries _method for Rails
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'follow',
      headers: { Accept: 'text/html' },
    })
      .then((response) => {
        window.location.replace(response.url || form.action);
      })
      .catch(() => {
        form.submit();
      });
  }
}
